<ds-modal
  class="finding-details-modal"
  [modal]="modal"
  [title]="modalTitle"
  [titleHeadingStyle]="'h2'"
  [beforeClose]="beforeClose"
  #modalRef
>
  <ng-template ds-modal-header-actions>
    <div class="finding-modal-header-actions">
      <div class="finding-modal-header-actions-left">
        <button
          ds-button
          type="button"
          [variant]="DsButtonVariants.microAction"
          [microActionIcon]="Icons.ShareNodes"
          [attr.aria-label]="'action_share_finding' | translate"
          (click)="openShareModal()"
        >
          {{ 'action_share_finding' | translate }}
        </button>
      </div>
      <div class="finding-modal-header-actions-right">
        <button
          ds-button
          type="button"
          [variant]="DsButtonVariants.microAction"
          [microActionIcon]="Icons.ArrowLeft"
          [attr.aria-label]="'action_previous_finding' | translate"
          [disabled]="!navigation?.canGoPrevious"
          (click)="navigation?.goToPrevious()"
          data-test-id="finding-nav-previous"
        >
          {{ 'action_previous_finding' | translate }}
        </button>
        <button
          ds-button
          type="button"
          [variant]="DsButtonVariants.microAction"
          [microActionIcon]="Icons.ArrowRight"
          [attr.aria-label]="'action_next_finding' | translate"
          [disabled]="!navigation?.canGoNext"
          (click)="navigation?.goToNext()"
          data-test-id="finding-nav-next"
        >
          {{ 'action_next_finding' | translate }}
        </button>
      </div>
    </div>
  </ng-template>
  <app-issues-view-details
    [toolName]="toolName"
    [scanId]="scanId"
    [issue]="issue"
    [ruleDetails]="ruleDetails"
    [isDigitalAssetFindingsEnabled]="isDigitalAssetFindingsEnabled"
    (dismissFinding)="onDismissFinding()"
    (restoreFinding)="onRestoreFinding()"
    (createTask)="onCreateTask()"
    (navigatedAway)="onModalClosed()"
  ></app-issues-view-details>
</ds-modal>
